import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CmxWebComponentsModule } from '@cmx-web-components/angular';

import { AlertsOutputComponent } from './alerts/alerts-output.component';
import { LoginComponent } from './login/login.component';
import { LoaderComponent } from './loader/loader.component';

import { IamAuthService, MsalBroadcastService, MsalService } from '@cemex-core/msal-services-v1';
import { HttpCemex } from '@cemex-core/angular-services-v8';

@NgModule({
  declarations: [AlertsOutputComponent, LoaderComponent, LoginComponent],
  imports: [CommonModule, TranslateModule.forChild(), FormsModule, ReactiveFormsModule, CmxWebComponentsModule],
  exports: [AlertsOutputComponent, LoaderComponent, LoginComponent],
  providers: [
    {
      provide: IamAuthService,
      deps: [HttpCemex, MsalService, MsalBroadcastService],
      useClass: IamAuthService,
    },
  ],
})
export class CmxClientComponentsModule {}
